document.addEventListener("click", function (e) {
  console.log("this script is working")
  if (
    e.target.classList.contains("country-and-flag") ||
    e.target.closest(".country-and-flag")
  ) {
    var target = e.target.classList.contains("country-and-flag")
      ? e.target
      : e.target.closest(".country-and-flag");
    var parent = target.closest(".country-localization2-container");
    var target_ = parent.querySelector(".all-country-list-container");
    var caretIcon = parent.querySelector(".icon-caret"); 
    // console.log(target, parent, target_)
    if (target_.classList.contains("active-country")) {
      target_.classList.remove("active-country");
      caretIcon.style.transform = "rotate(0deg)"; 
    } else {
      target_.classList.add("active-country");
      caretIcon.style.transform = "rotate(180deg)";
    }
  } else {
    // Clicked outside the country-and-flag element
    var allCountryListContainer = document.querySelector(".all-country-list-container");
    if (allCountryListContainer && allCountryListContainer.classList.contains("active-country")) {
      allCountryListContainer.classList.remove("active-country");
      
      var caretIcon = document.querySelector(".icon-caret");
      caretIcon.style.transform = "rotate(0deg)";
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var countryListItems = document.querySelectorAll(".custom-CountryList-item");
  let countryNameSpan, countryFlagImg;
  if (window.innerWidth <= 768) {
    countryNameSpan = document.querySelector("#mobCountry .countrybtn-name");
    countryFlagImg = document.querySelector("#mobCountry .countrybtn-flag");
  } else {
    countryNameSpan = document.querySelector("#deskCountry .countrybtn-name");
    countryFlagImg = document.querySelector("#deskCountry .countrybtn-flag");
  }
  updateCountryInfo();

  // Update country information on every URL change
  window.addEventListener("popstate", updateCountryInfo);

  function updateCountryInfo() {
    var currentUrl = window.location.pathname;
    var urlParts = currentUrl.split("/");
    var languageCode = urlParts[1]; // Assuming the language code is at index 2
    console.log("parts",urlParts, "code",languageCode)

    // Find items with matching data-value
    var matchingItems = Array.from(countryListItems).filter(
      (item) => item.getAttribute("data-value") === languageCode
    );
    if (matchingItems.length > 0) {
      // If there is only one matching item, treat it differently
      if (matchingItems.length === 2) {
        var countryImg = matchingItems[0].querySelector(".country-img img");
        var countryName = matchingItems[0].querySelector(".country-name");
    
        if (countryImg) {
          countryNameSpan.innerText = countryName.innerText.trim();
          countryFlagImg.src = countryImg.src;
        }
      } else {
        // If multiple items share the same data-value, target a specific one (e.g., the first one)
        var specificItem = matchingItems[matchingItems.length - 1];
        var countryImg = specificItem.querySelector(".country-img img");
        var countryName = specificItem.querySelector(".country-name");
        if (countryImg) {
          countryNameSpan.innerText = countryName.innerHTML;
          countryFlagImg.src = countryImg.src;
        }
      }
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var listarray = ["en-al","bg-bg", "hr-hr","el-cy","cs-cz","et-ee","en-fi","fr-fr","de-de","hu-hu","el-gr","en-ie","lv-lv","lt-lt","en-mt","ro-ro","pl-pl","ro-md","sr-sr","sk-sk","sl-sl","es-es","tr-tr","ru-ru","en-en","en-rs","uk-uk"];
  let contains = false;
  listarray.forEach(function(element) {
    // console.log("elem",element)
    if (window.location.href.includes(element)) {
      contains = true;
    }
  });
  var listItems;
  if (window.innerWidth <= 768) {
     listItems = document.querySelectorAll('.custom-CountryList-item');
  } else {
    listItems = document.querySelectorAll('.custom-CountryList-item');
  }
  listItems.forEach(function(item) {
    item.addEventListener('click', function(event) {
      event.preventDefault();
      var dataValue = item.getAttribute('data-value');
      var currentUrl = new URL(window.location.href);
      var pathnameSegments = currentUrl.pathname.split('/');
      console.log("contains",contains)
      // console.log(dataValue, currentUrl, pathnameSegments)
      if(dataValue !== ""){
        if(contains){
          pathnameSegments.splice(1, 1);
        } 
        pathnameSegments.splice(1, 0, dataValue);
        currentUrl.pathname = pathnameSegments.join('/');
      } else {
        pathnameSegments.splice(1, 1);
        currentUrl.pathname = pathnameSegments.join('/');
      }

      // Reload the page with the new URL
      var currentURL = currentUrl.href;
      console.log(currentUrl)
      if (dataValue == "en-en" && currentURL.includes("blogs")) {
        currentURL = currentURL.replace("it", "en");
        window.location.href = currentURL;
      } else if (dataValue == "" && currentURL.includes("blogs")) {
        currentURL = currentURL.replace("en", "it");
        window.location.href = currentURL;
      } else {
        window.location.href = currentURL;
      }
    });
  });
});


// remove en from the country name when the page is load
window.onload = function() {
var countryCodes = [
    "bg-bg", "hr-hr", "el-cy", "cs-cz", "et-ee", "fr-fr", "de-de",
    "hu-hu", "el-gr", "lv-lv", "lt-lt", "ro-ro", "pl-pl",
    "ro-md", "sr-sr", "sk-sk", "sl-sl", "es-es", "tr-tr", "ru-ru",
    "uk-uk"
];

var currentUrl = window.location.href;

let filterUrl = new URL(window.location.href);
let pathParts = filterUrl.pathname.split('/').filter(Boolean);

if (pathParts[0] == "blogs" && pathParts[1] == "en") {
  if (pathParts.length >= 2) {
    // Take only the first two segments: "blogs" and "en"
    let basePath = '/' + pathParts.slice(0, 2).join('/');
    filterUrl.pathname = basePath;
  }
  currentUrl = filterUrl.href;
}

// Get only the first path segment (language code)
  let firstSegment = pathParts[0] || "";

function getCountryCodeToReplace(url) {
    for (var i = 0; i < countryCodes.length; i++) {
        var code = countryCodes[i].split('-')[1]; 
        if (segment === 'en-' + code) {
            return countryCodes[i];
        }
    }
    return null; // No match found
}

// if (currentUrl.endsWith("/en")) {
//     var newUrl = currentUrl.replace("/en", "");
//     window.location.href = newUrl;
//     return;
// }

// Get the new country code
var newCountryCode = getCountryCodeToReplace(currentUrl);


if (newCountryCode) {
    var newUrl = currentUrl.replace(/en-[a-z]{2}/, newCountryCode); 
    window.location.href = newUrl;
}
}